var render, staticRenderFns
import script from "./customer_maintenance.vue?vue&type=script&lang=js"
export * from "./customer_maintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7965c99c')) {
      api.createRecord('7965c99c', component.options)
    } else {
      api.reload('7965c99c', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/organization_management/associated/customer_maintenance/customer_maintenance.vue"
export default component.exports